// Typographic normalisation for copy that comes from SHARED app source.
//
// The website sets real apostrophes (’), because a straight ' is a typewriter
// mark and every brand with a design team sets the proper one. But some of the
// copy on this site is not the website's to edit: the four "how a shift goes"
// cards are rendered straight out of shared/howItWorksArt.js, which is the
// WORKER APP's copy, reviewed in the Copy studio and shown to real users in the
// app. Rewriting it here to suit web typography would quietly fork a string that
// is supposed to have one source.
//
// So the glyph is normalised at RENDER time, on the website only. The app keeps
// its string, the website draws it properly, and nothing forks.
//
// ⛔ Apostrophes only. Not quotation marks: a naive opening/closing quote
// substitution gets it wrong on anything starting with an elision, and no shared
// copy on this site uses quotes.

export const smart = (s) => (typeof s === 'string' ? s.replace(/(?<=\w)'(?=\w)/g, '’') : s)
